module.exports = __webpack_public_path__ + "static/media/expand.40e74560.svg";